import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    "data-test": "organization-wizard-modal",
    class: "flex max-h-[calc(100vh-2rem)] w-full flex-col overflow-hidden rounded-xl bg-white shadow-xl"
};
const _hoisted_2 = { class: "flex items-start justify-between gap-4 border-b border-ewhite-200 px-6 py-4" };
const _hoisted_3 = { class: "text-sm font-medium text-eorange-600" };
const _hoisted_4 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = { class: "flex flex-1 flex-col gap-5 overflow-y-auto px-6 py-5" };
const _hoisted_7 = ["aria-label"];
const _hoisted_8 = { class: "block text-[11px] text-eblack-400" };
const _hoisted_9 = { class: "text-xs text-eblack-400" };
const _hoisted_10 = {
    key: 0,
    class: "rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600"
};
const _hoisted_11 = {
    key: 1,
    "data-test": "org-type-step",
    class: "flex flex-col gap-4"
};
const _hoisted_12 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_13 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_14 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_15 = { class: "text-sm font-semibold" };
const _hoisted_16 = { class: "mt-1 block text-sm text-eblack-500" };
const _hoisted_17 = { class: "text-sm font-semibold" };
const _hoisted_18 = { class: "mt-1 block text-sm text-eblack-500" };
const _hoisted_19 = {
    key: 2,
    "data-test": "organization-step",
    class: "flex flex-col gap-5"
};
const _hoisted_20 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_21 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_22 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_23 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_24 = { class: "grid gap-3 md:grid-cols-3" };
const _hoisted_25 = ["value"];
const _hoisted_26 = { value: "" };
const _hoisted_27 = ["value"];
const _hoisted_28 = { value: "" };
const _hoisted_29 = ["value"];
const _hoisted_30 = {
    key: 0,
    class: "mt-2 text-xs text-egreen-700"
};
const _hoisted_31 = {
    key: 0,
    "data-test": "provider-fields",
    class: "flex flex-col gap-3"
};
const _hoisted_32 = {
    key: 3,
    "data-test": "bank-accounts-step",
    class: "flex flex-col gap-5"
};
const _hoisted_33 = { class: "flex flex-col gap-3 md:flex-row md:items-start md:justify-between" };
const _hoisted_34 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_35 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_36 = { class: "mb-3 flex items-center justify-between gap-3" };
const _hoisted_37 = { class: "text-sm font-semibold text-eblack-800" };
const _hoisted_38 = ["data-test", "title", "onClick"];
const _hoisted_39 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_40 = ["onUpdate:modelValue", "data-test"];
const _hoisted_41 = ["onUpdate:modelValue", "data-test"];
const _hoisted_42 = { class: "mt-3 grid gap-3 md:grid-cols-[1fr_140px]" };
const _hoisted_43 = ["onUpdate:modelValue", "data-test"];
const _hoisted_44 = ["onUpdate:modelValue", "data-test"];
const _hoisted_45 = ["value"];
const _hoisted_46 = {
    key: 4,
    "data-test": "billing-step",
    class: "flex flex-col gap-5"
};
const _hoisted_47 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_48 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_49 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_50 = { value: "" };
const _hoisted_51 = ["value"];
const _hoisted_52 = { value: "" };
const _hoisted_53 = ["value"];
const _hoisted_54 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_55 = { value: "onvo_card" };
const _hoisted_56 = { value: "manual_transfer" };
const _hoisted_57 = { value: "manual_other" };
const _hoisted_58 = { class: "flex items-center gap-2 text-sm font-medium text-eblack-800" };
const _hoisted_59 = { class: "rounded-lg bg-ewhite-50 px-3 py-2 text-sm text-eblack-600" };
const _hoisted_60 = {
    key: 5,
    "data-test": "owner-step",
    class: "flex flex-col gap-5"
};
const _hoisted_61 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_62 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_63 = { class: "grid gap-3 md:grid-cols-2" };
const _hoisted_64 = {
    key: 6,
    class: "rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600"
};
const _hoisted_65 = { class: "flex justify-between gap-2 border-t border-ewhite-200 bg-white px-6 py-4" };
const _hoisted_66 = ["disabled"];
import { computed, defineComponent, h, onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { IconPlus, IconTrash, IconX } from "@tabler/icons-vue";
import FileUploadDropzone from "@/components/ui/FileUploadDropzone.vue";
import PhoneInput from "@/components/ui/PhoneInput.vue";
import data from "@/core/data";
import { useBillingFormatting, useBillingStore } from "@/domains/billing";
import { useOrganizations } from "../composables";
import { buildCreateOrganizationPayload, createDefaultOrganizationWizardState, createOrganizationSchema, defaultOrganizationBankAccountInput, organizationBankAccountCurrencyOptions, validateOrganizationWizardStep, } from "../models";
const activeStepClass = "border-eorange-300 bg-eorange-50 text-eorange-700";
const inactiveStepClass = "border-ewhite-200 bg-white text-eblack-500";
const activeTypeClass = "border-eorange-400 bg-eorange-50 text-eorange-700";
const inactiveTypeClass = "border-ewhite-300 bg-white text-eblack-600 hover:bg-ewhite-50";
const labelClass = "text-sm font-medium text-eblack-800";
const inputClass = "block w-full rounded-lg border border-ewhite-300 bg-white px-3 py-2 text-sm text-eblack-900 placeholder:text-eblack-400 focus:border-eorange-400 focus:ring-eorange-200 disabled:bg-ewhite-100 disabled:text-eblack-500";
const errorClass = "text-xs text-red-500";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganizationFormSidebar',
    props: {
        organization: {}
    },
    emits: ["close", "saved"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        const { money } = useBillingFormatting();
        const steps = computed(() => [
            { key: "type", label: t("organization.auto.tipo") },
            { key: "organization", label: t("organization.auto.organizacion") },
            { key: "bank_accounts", label: t("organization.auto.cuentas") },
            { key: "billing", label: t("organization.auto.facturacion") },
            { key: "owner", label: t("organization.auto.propietario") },
        ].filter((step) => step.key !== "billing" || form.org_type === "concierge"));
        const { createOrganization, isSaving, error } = useOrganizations({
            autoLoad: false,
        });
        const billingStore = useBillingStore();
        const countries = data.countriesStatesCities;
        const validationErrors = reactive({});
        const formError = ref("");
        const currentStep = ref("type");
        const form = reactive(createDefaultOrganizationWizardState());
        const currentStepIndex = computed(() => steps.value.findIndex((step) => step.key === currentStep.value));
        const organizationCountry = computed(() => countries.find((country) => country.iso2 === form.organization.country));
        const organizationStates = computed(() => organizationCountry.value?.states ?? []);
        const organizationCities = computed(() => findCities(organizationStates.value, form.organization.location_one));
        const activeBillingPlans = computed(() => billingStore.plans.filter((plan) => plan.status === "active"));
        const selectedBillingPlan = computed(() => activeBillingPlans.value.find((plan) => String(plan.id) === form.billing_setup.plan_id));
        const selectedPlanPrices = computed(() => {
            const plan = selectedBillingPlan.value;
            if (!plan)
                return [];
            if (plan.price_versions.length > 0)
                return plan.price_versions;
            return plan.price.id
                ? [
                    {
                        id: plan.price.id,
                        currency: plan.price.currency,
                        unit_amount_minor: plan.price.unit_amount_minor,
                        billing_interval: plan.billing_interval,
                        is_active: Boolean(plan.price.is_active),
                        effective_from: plan.price.effective_from ?? "",
                    },
                ]
                : [];
        });
        const billingSetupHelp = computed(() => form.billing_setup.payment_method_type === "onvo_card"
            ? t("organization.auto.ayuda_tarjeta_onvo")
            : t("organization.auto.ayuda_pago_manual"));
        onMounted(() => {
            void billingStore.fetchPlans();
        });
        const FieldWrapper = defineComponent({
            name: "FieldWrapper",
            props: {
                label: { type: String, required: true },
                errorKey: { type: String, required: true },
                optional: { type: Boolean, default: false },
            },
            setup(props, { slots }) {
                return () => h("div", { class: "flex flex-col gap-1.5" }, [
                    h("label", { class: labelClass }, [
                        props.label,
                        props.optional
                            ? h("span", { class: "ml-1 text-xs font-normal text-eblack-400" }, t("organization.auto.optional_marker"))
                            : h("span", {
                                class: "ml-0.5 text-eorange-500",
                                "aria-hidden": "true",
                            }, "*"),
                    ]),
                    slots.default?.(),
                    validationErrors[props.errorKey]
                        ? h("p", { class: errorClass }, validationErrors[props.errorKey])
                        : null,
                ]);
            },
        });
        function selectOrgType(orgType) {
            form.org_type = orgType;
            delete validationErrors.org_type;
        }
        function findCities(states, stateName) {
            return (states.find((state) => normalizeLocation(state.name) === stateName)
                ?.cities ?? []);
        }
        function normalizeLocation(value) {
            return value.toLowerCase().trim();
        }
        function resetOrganizationLocation() {
            form.organization.location_one = "";
            form.organization.location_two = "";
            form.organization.country_name = organizationCountry.value?.name ?? "";
        }
        function handleLogoUploaded(result) {
            form.organization.image_storage_id = result.storageIds?.[0] ?? null;
        }
        function addBankAccount() {
            form.bank_accounts.push({ ...defaultOrganizationBankAccountInput });
        }
        function selectDefaultPlanPrice() {
            form.billing_setup.plan_price_id = String(selectedPlanPrices.value[0]?.id ?? "");
        }
        function removeBankAccount(index) {
            if (form.bank_accounts.length <= 1)
                return;
            form.bank_accounts.splice(index, 1);
            setValidationErrors({});
            formError.value = "";
        }
        function fieldError(key) {
            return validationErrors[key];
        }
        function setValidationErrors(errors) {
            Object.keys(validationErrors).forEach((key) => delete validationErrors[key]);
            Object.entries(errors).forEach(([key, value]) => {
                validationErrors[key] = value;
            });
        }
        function validateCurrentStep() {
            formError.value = "";
            const errors = validateOrganizationWizardStep(form, currentStep.value);
            setValidationErrors(errors);
            if (Object.keys(errors).length) {
                formError.value = t("organization.auto.revise_campos_marcados");
                return false;
            }
            return true;
        }
        function goNext() {
            if (!validateCurrentStep())
                return;
            const nextIndex = Math.min(currentStepIndex.value + 1, steps.value.length - 1);
            currentStep.value = steps.value[nextIndex].key;
        }
        function goBack() {
            formError.value = "";
            setValidationErrors({});
            const previousIndex = Math.max(currentStepIndex.value - 1, 0);
            currentStep.value = steps.value[previousIndex].key;
        }
        function handleClose() {
            emit("close");
        }
        async function handleSubmit() {
            if (!validateCurrentStep())
                return;
            form.organization.country_name =
                organizationCountry.value?.name ?? form.organization.country_name;
            const payload = buildCreateOrganizationPayload(form);
            const parsed = createOrganizationSchema.safeParse(payload);
            if (!parsed.success) {
                const nextErrors = {};
                parsed.error.issues.forEach((issue) => {
                    nextErrors[issue.path.join(".")] = issue.message;
                });
                setValidationErrors(nextErrors);
                formError.value = t("organization.auto.revise_campos_marcados");
                return;
            }
            setValidationErrors({});
            const organization = await createOrganization(parsed.data);
            emit("saved", organization);
            emit("close");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("organization.auto.consola_global")), 1),
                        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("organization.auto.nueva_organizacion")), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "rounded-lg p-2 text-eblack-400 transition hover:bg-ewhite-100 hover:text-eblack-700",
                        "aria-label": _ctx.$t('organization.auto.cerrar'),
                        onClick: handleClose
                    }, [
                        _createVNode(_unref(IconX), { class: "h-5 w-5" })
                    ], 8, _hoisted_5)
                ]),
                _createElementVNode("form", {
                    "data-test": "organization-wizard-form",
                    class: "flex min-h-0 flex-1 flex-col",
                    onSubmit: _withModifiers(handleSubmit, ["prevent"])
                }, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("nav", {
                            class: "grid grid-cols-2 gap-2 md:grid-cols-4",
                            "aria-label": _ctx.$t('organization.auto.progreso_de_creacion')
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (stepItem, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: stepItem.key,
                                    class: _normalizeClass(["rounded-lg border px-3 py-2 text-xs font-medium",
                                        index <= currentStepIndex.value ? activeStepClass : inactiveStepClass
                                    ])
                                }, [
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("organization.auto.step_number", { number: index + 1 })), 1),
                                    _createTextVNode(" " + _toDisplayString(stepItem.label), 1)
                                ], 2));
                            }), 128))
                        ], 8, _hoisted_7),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("organization.auto.leyenda_campos_requeridos")), 1),
                        (formError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(formError.value), 1))
                            : _createCommentVNode("", true),
                        (currentStep.value === 'type')
                            ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("organization.auto.seleccione_el_tipo_de_organizacion")), 1),
                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("organization.auto.esta_seleccion_define_los_campos_y_permisos_inic")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        "data-test": "org-type-concierge",
                                        class: _normalizeClass(["rounded-lg border p-4 text-left transition-colors",
                                            form.org_type === 'concierge'
                                                ? activeTypeClass
                                                : inactiveTypeClass
                                        ]),
                                        onClick: _cache[0] || (_cache[0] = ($event) => (selectOrgType('concierge')))
                                    }, [
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("organization.auto.concierge")), 1),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("organization.auto.gestiona_clientes_itinerarios_y_reservas_con_pro")), 1)
                                    ], 2),
                                    _createElementVNode("button", {
                                        type: "button",
                                        "data-test": "org-type-provider",
                                        class: _normalizeClass(["rounded-lg border p-4 text-left transition-colors",
                                            form.org_type === 'provider'
                                                ? activeTypeClass
                                                : inactiveTypeClass
                                        ]),
                                        onClick: _cache[1] || (_cache[1] = ($event) => (selectOrgType('provider')))
                                    }, [
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("organization.auto.proveedor")), 1),
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("organization.auto.publica_servicios_calendarios_y_disponibilidad_o")), 1)
                                    ], 2)
                                ]),
                                (fieldError('org_type'))
                                    ? (_openBlock(), _createElementBlock("p", {
                                        key: 0,
                                        class: _normalizeClass(errorClass)
                                    }, _toDisplayString(fieldError("org_type")), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : (currentStep.value === 'organization')
                                ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t("organization.auto.informacion_de_la_organizacion")), 1),
                                        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("organization.auto.estos_datos_tambien_se_usaran_para_crear_el_perf")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_unref(FieldWrapper), {
                                            label: _ctx.$t('organization.auto.nombre_de_la_organizacion'),
                                            "error-key": "organization.name"
                                        }, {
                                            default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.organization.name) = $event)),
                                                    "data-test": "organization-name",
                                                    type: "text",
                                                    class: _normalizeClass(inputClass)
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        form.organization.name,
                                                        void 0,
                                                        { trim: true }
                                                    ]
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["label"]),
                                        _createVNode(_unref(FieldWrapper), {
                                            label: _ctx.$t('organization.auto.identificacion_legal'),
                                            "error-key": "organization.legal_id"
                                        }, {
                                            default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.organization.legal_id) = $event)),
                                                    "data-test": "organization-legal-id",
                                                    type: "text",
                                                    class: _normalizeClass(inputClass)
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        form.organization.legal_id,
                                                        void 0,
                                                        { trim: true }
                                                    ]
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["label"])
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createVNode(_unref(FieldWrapper), {
                                            label: _ctx.$t('organization.auto.correo_de_contacto'),
                                            "error-key": "organization.email"
                                        }, {
                                            default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.organization.email) = $event)),
                                                    "data-test": "organization-email",
                                                    type: "email",
                                                    class: _normalizeClass(inputClass)
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        form.organization.email,
                                                        void 0,
                                                        { trim: true }
                                                    ]
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["label"]),
                                        _createVNode(_unref(FieldWrapper), {
                                            label: _ctx.$t('organization.auto.telefono_de_contacto'),
                                            "error-key": "organization.phone"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(PhoneInput, {
                                                    modelValue: form.organization.phone,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.organization.phone) = $event)),
                                                    "data-test": "organization-phone",
                                                    required: "",
                                                    "default-country": form.organization.country || 'CR',
                                                    invalid: Boolean(fieldError('organization.phone'))
                                                }, null, 8, ["modelValue", "default-country", "invalid"])
                                            ]),
                                            _: 1
                                        }, 8, ["label"])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createVNode(_unref(FieldWrapper), {
                                            label: _ctx.$t('organization.auto.pais'),
                                            "error-key": "organization.country"
                                        }, {
                                            default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.organization.country) = $event)),
                                                    "data-test": "organization-country",
                                                    class: _normalizeClass(inputClass),
                                                    onChange: resetOrganizationLocation
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: country.iso2,
                                                            value: country.iso2
                                                        }, _toDisplayString(country.name), 9, _hoisted_25));
                                                    }), 128))
                                                ], 544), [
                                                    [_vModelSelect, form.organization.country]
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["label"]),
                                        _createVNode(_unref(FieldWrapper), {
                                            label: _ctx.$t('organization.auto.provincia_estado'),
                                            "error-key": "organization.location_one"
                                        }, {
                                            default: _withCtx(() => [
                                                (organizationStates.value.length)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                        key: 0,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.organization.location_one) = $event)),
                                                        "data-test": "organization-location-one",
                                                        class: _normalizeClass(inputClass),
                                                        onChange: _cache[8] || (_cache[8] = ($event) => (form.organization.location_two = ''))
                                                    }, [
                                                        _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t("organization.auto.seleccione")), 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationStates.value, (state) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: state.id,
                                                                value: normalizeLocation(state.name)
                                                            }, _toDisplayString(state.name), 9, _hoisted_27));
                                                        }), 128))
                                                    ], 544)), [
                                                        [_vModelSelect, form.organization.location_one]
                                                    ])
                                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                        key: 1,
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.organization.location_one) = $event)),
                                                        "data-test": "organization-location-one",
                                                        type: "text",
                                                        class: _normalizeClass(inputClass)
                                                    }, null, 512)), [
                                                        [
                                                            _vModelText,
                                                            form.organization.location_one,
                                                            void 0,
                                                            { trim: true }
                                                        ]
                                                    ])
                                            ]),
                                            _: 1
                                        }, 8, ["label"]),
                                        _createVNode(_unref(FieldWrapper), {
                                            label: _ctx.$t('organization.auto.canton_ciudad'),
                                            "error-key": "organization.location_two"
                                        }, {
                                            default: _withCtx(() => [
                                                (organizationCities.value.length)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                        key: 0,
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.organization.location_two) = $event)),
                                                        "data-test": "organization-location-two",
                                                        class: _normalizeClass(inputClass)
                                                    }, [
                                                        _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t("organization.auto.seleccione")), 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationCities.value, (city) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: city.id,
                                                                value: normalizeLocation(city.name)
                                                            }, _toDisplayString(city.name), 9, _hoisted_29));
                                                        }), 128))
                                                    ], 512)), [
                                                        [_vModelSelect, form.organization.location_two]
                                                    ])
                                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                        key: 1,
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.organization.location_two) = $event)),
                                                        "data-test": "organization-location-two",
                                                        type: "text",
                                                        class: _normalizeClass(inputClass)
                                                    }, null, 512)), [
                                                        [
                                                            _vModelText,
                                                            form.organization.location_two,
                                                            void 0,
                                                            { trim: true }
                                                        ]
                                                    ])
                                            ]),
                                            _: 1
                                        }, 8, ["label"])
                                    ]),
                                    _createVNode(_unref(FieldWrapper), {
                                        label: _ctx.$t('organization.auto.direccion_o_referencia'),
                                        "error-key": "organization.location_three",
                                        optional: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((form.organization.location_three) = $event)),
                                                "data-test": "organization-location-three",
                                                type: "text",
                                                class: _normalizeClass(inputClass)
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    form.organization.location_three,
                                                    void 0,
                                                    { trim: true }
                                                ]
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["label"]),
                                    _createVNode(_unref(FieldWrapper), {
                                        label: _ctx.$t('organization.auto.logo_de_la_organizacion'),
                                        "error-key": "organization.image_storage_id",
                                        optional: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(FileUploadDropzone, {
                                                folder: "logos",
                                                "org-context": "global",
                                                multiple: false,
                                                "max-files": 1,
                                                "max-file-size": 3 * 1024 * 1024,
                                                "allowed-types": ['image/jpeg', 'image/jpg', 'image/png'],
                                                "auto-upload": true,
                                                onUploadComplete: handleLogoUploaded
                                            }),
                                            (form.organization.image_storage_id)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t("organization.auto.logo_cargado_correctamente")), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }, 8, ["label"]),
                                    (form.org_type === 'provider')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createVNode(_unref(FieldWrapper), {
                                                label: _ctx.$t('organization.auto.descripcion_del_proveedor'),
                                                "error-key": "organization.description"
                                            }, {
                                                default: _withCtx(() => [
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((form.organization.description) = $event)),
                                                        "data-test": "organization-description",
                                                        rows: "3",
                                                        class: _normalizeClass(inputClass)
                                                    }, null, 512), [
                                                        [
                                                            _vModelText,
                                                            form.organization.description,
                                                            void 0,
                                                            { trim: true }
                                                        ]
                                                    ])
                                                ]),
                                                _: 1
                                            }, 8, ["label"]),
                                            _createVNode(_unref(FieldWrapper), {
                                                label: _ctx.$t('organization.auto.contacto_secundario'),
                                                "error-key": "organization.secondary_contact",
                                                optional: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(PhoneInput, {
                                                        modelValue: form.organization.secondary_contact,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((form.organization.secondary_contact) = $event)),
                                                        "data-test": "organization-secondary-contact",
                                                        "default-country": form.organization.country || 'CR',
                                                        invalid: Boolean(fieldError('organization.secondary_contact'))
                                                    }, null, 8, ["modelValue", "default-country", "invalid"])
                                                ]),
                                                _: 1
                                            }, 8, ["label"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : (currentStep.value === 'bank_accounts')
                                    ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.$t("organization.auto.cuentas_bancarias")), 1),
                                                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("organization.auto.registre_las_cuentas_iban_iniciales_de_la_organi")), 1)
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                "data-test": "add-bank-account",
                                                class: "inline-flex items-center justify-center gap-2 rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-medium text-eblack-700",
                                                onClick: addBankAccount
                                            }, [
                                                _createVNode(_unref(IconPlus), { class: "h-4 w-4" }),
                                                _createTextVNode(_toDisplayString(_ctx.$t("organization.auto.agregar_cuenta")), 1)
                                            ])
                                        ]),
                                        (fieldError('bank_accounts'))
                                            ? (_openBlock(), _createElementBlock("p", {
                                                key: 0,
                                                class: _normalizeClass(errorClass)
                                            }, _toDisplayString(fieldError("bank_accounts")), 1))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.bank_accounts, (account, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "rounded-lg border border-ewhite-200 bg-white p-4"
                                            }, [
                                                _createElementVNode("div", _hoisted_36, [
                                                    _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("organization.auto.account_number", { number: index + 1 })), 1),
                                                    (form.bank_accounts.length > 1)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            "data-test": `remove-bank-account-${index}`,
                                                            class: "inline-flex items-center justify-center rounded-lg border border-red-200 p-2 text-red-600",
                                                            title: _ctx.$t('organization.auto.eliminar_cuenta'),
                                                            onClick: ($event) => (removeBankAccount(index))
                                                        }, [
                                                            _createVNode(_unref(IconTrash), { class: "h-4 w-4" })
                                                        ], 8, _hoisted_38))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_39, [
                                                    _createVNode(_unref(FieldWrapper), {
                                                        label: _ctx.$t('organization.auto.banco'),
                                                        "error-key": `bank_accounts.${index}.bank_name`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((account.bank_name) = $event),
                                                                "data-test": `bank-account-bank-name-${index}`,
                                                                type: "text",
                                                                class: _normalizeClass(inputClass)
                                                            }, null, 8, _hoisted_40), [
                                                                [
                                                                    _vModelText,
                                                                    account.bank_name,
                                                                    void 0,
                                                                    { trim: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["label", "error-key"]),
                                                    _createVNode(_unref(FieldWrapper), {
                                                        label: _ctx.$t('organization.auto.beneficiario'),
                                                        "error-key": `bank_accounts.${index}.beneficiary_name`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((account.beneficiary_name) = $event),
                                                                "data-test": `bank-account-beneficiary-name-${index}`,
                                                                type: "text",
                                                                class: _normalizeClass(inputClass)
                                                            }, null, 8, _hoisted_41), [
                                                                [
                                                                    _vModelText,
                                                                    account.beneficiary_name,
                                                                    void 0,
                                                                    { trim: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["label", "error-key"])
                                                ]),
                                                _createElementVNode("div", _hoisted_42, [
                                                    _createVNode(_unref(FieldWrapper), {
                                                        label: _ctx.$t('organization.auto.cuenta_bancaria_iban'),
                                                        "error-key": `bank_accounts.${index}.iban`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": ($event) => ((account.iban) = $event),
                                                                "data-test": `bank-account-iban-${index}`,
                                                                type: "text",
                                                                class: _normalizeClass([inputClass, 'font-mono uppercase'])
                                                            }, null, 10, _hoisted_43), [
                                                                [
                                                                    _vModelText,
                                                                    account.iban,
                                                                    void 0,
                                                                    { trim: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["label", "error-key"]),
                                                    _createVNode(_unref(FieldWrapper), {
                                                        label: _ctx.$t('organization.auto.moneda'),
                                                        "error-key": `bank_accounts.${index}.currency`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _withDirectives(_createElementVNode("select", {
                                                                "onUpdate:modelValue": ($event) => ((account.currency) = $event),
                                                                "data-test": `bank-account-currency-${index}`,
                                                                class: _normalizeClass(inputClass)
                                                            }, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizationBankAccountCurrencyOptions), (currency) => {
                                                                    return (_openBlock(), _createElementBlock("option", {
                                                                        key: currency,
                                                                        value: currency
                                                                    }, _toDisplayString(currency), 9, _hoisted_45));
                                                                }), 128))
                                                            ], 8, _hoisted_44), [
                                                                [_vModelSelect, account.currency]
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["label", "error-key"])
                                                ])
                                            ]));
                                        }), 128))
                                    ]))
                                    : (currentStep.value === 'billing')
                                        ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.$t("organization.auto.plan_y_facturacion")), 1),
                                                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("organization.auto.seleccione_plan_metodo_pago")), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_49, [
                                                _createVNode(_unref(FieldWrapper), {
                                                    label: _ctx.$t('organization.auto.plan'),
                                                    "error-key": "billing_setup.plan_id"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((form.billing_setup.plan_id) = $event)),
                                                            "data-test": "billing-plan",
                                                            class: _normalizeClass(inputClass),
                                                            onChange: selectDefaultPlanPrice
                                                        }, [
                                                            _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.$t("organization.auto.seleccione")), 1),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeBillingPlans.value, (plan) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    key: plan.id,
                                                                    value: String(plan.id)
                                                                }, _toDisplayString(plan.name), 9, _hoisted_51));
                                                            }), 128))
                                                        ], 544), [
                                                            [_vModelSelect, form.billing_setup.plan_id]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"]),
                                                _createVNode(_unref(FieldWrapper), {
                                                    label: _ctx.$t('organization.auto.version_de_precio'),
                                                    "error-key": "billing_setup.plan_price_id"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((form.billing_setup.plan_price_id) = $event)),
                                                            "data-test": "billing-plan-price",
                                                            class: _normalizeClass(inputClass)
                                                        }, [
                                                            _createElementVNode("option", _hoisted_52, _toDisplayString(_ctx.$t("organization.auto.seleccione")), 1),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPlanPrices.value, (price) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    key: price.id,
                                                                    value: String(price.id)
                                                                }, _toDisplayString(_unref(money)(price.unit_amount_minor, price.currency)), 9, _hoisted_53));
                                                            }), 128))
                                                        ], 512), [
                                                            [_vModelSelect, form.billing_setup.plan_price_id]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"])
                                            ]),
                                            _createElementVNode("div", _hoisted_54, [
                                                _createVNode(_unref(FieldWrapper), {
                                                    label: _ctx.$t('organization.auto.metodo_de_pago'),
                                                    "error-key": "billing_setup.payment_method_type"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((form.billing_setup.payment_method_type) = $event)),
                                                            "data-test": "billing-payment-method",
                                                            class: _normalizeClass(inputClass)
                                                        }, [
                                                            _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.$t("organization.auto.tarjeta_onvo")), 1),
                                                            _createElementVNode("option", _hoisted_56, _toDisplayString(_ctx.$t("organization.auto.transferencia_manual")), 1),
                                                            _createElementVNode("option", _hoisted_57, _toDisplayString(_ctx.$t("organization.auto.otro_manual")), 1)
                                                        ], 512), [
                                                            [_vModelSelect, form.billing_setup.payment_method_type]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"]),
                                                _createVNode(_unref(FieldWrapper), {
                                                    label: _ctx.$t('organization.auto.dias_gracia_vencimiento'),
                                                    "error-key": "billing_setup.grace_days_after_due"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((form.billing_setup.grace_days_after_due) = $event)),
                                                            "data-test": "billing-grace-days",
                                                            type: "number",
                                                            min: "0",
                                                            class: _normalizeClass(inputClass)
                                                        }, null, 512), [
                                                            [
                                                                _vModelText,
                                                                form.billing_setup.grace_days_after_due,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"])
                                            ]),
                                            _createElementVNode("label", _hoisted_58, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((form.billing_setup.trial.enabled) = $event)),
                                                    "data-test": "billing-trial-enabled",
                                                    type: "checkbox",
                                                    class: "rounded border-ewhite-300 text-eorange-500"
                                                }, null, 512), [
                                                    [_vModelCheckbox, form.billing_setup.trial.enabled]
                                                ]),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t("organization.auto.aplicar_prueba")), 1)
                                            ]),
                                            (form.billing_setup.trial.enabled)
                                                ? (_openBlock(), _createBlock(_unref(FieldWrapper), {
                                                    key: 0,
                                                    label: _ctx.$t('organization.auto.dias_de_prueba'),
                                                    "error-key": "billing_setup.trial.days"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((form.billing_setup.trial.days) = $event)),
                                                            "data-test": "billing-trial-days",
                                                            type: "number",
                                                            min: "1",
                                                            class: _normalizeClass(inputClass)
                                                        }, null, 512), [
                                                            [
                                                                _vModelText,
                                                                form.billing_setup.trial.days,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("p", _hoisted_59, _toDisplayString(billingSetupHelp.value), 1)
                                        ]))
                                        : (_openBlock(), _createElementBlock("section", _hoisted_60, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("h3", _hoisted_61, _toDisplayString(_ctx.$t("organization.auto.propietario")), 1),
                                                _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t("organization.auto.cree_las_credenciales_iniciales_para_la_persona_")), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_63, [
                                                _createVNode(_unref(FieldWrapper), {
                                                    label: _ctx.$t('organization.auto.nombre_del_propietario'),
                                                    "error-key": "owner.assigned_person"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((form.owner.assigned_person) = $event)),
                                                            "data-test": "owner-assigned-person",
                                                            type: "text",
                                                            class: _normalizeClass(inputClass)
                                                        }, null, 512), [
                                                            [
                                                                _vModelText,
                                                                form.owner.assigned_person,
                                                                void 0,
                                                                { trim: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"]),
                                                _createVNode(_unref(FieldWrapper), {
                                                    label: _ctx.$t('organization.auto.correo_del_propietario'),
                                                    "error-key": "owner.email"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((form.owner.email) = $event)),
                                                            "data-test": "owner-email",
                                                            type: "email",
                                                            class: _normalizeClass(inputClass)
                                                        }, null, 512), [
                                                            [
                                                                _vModelText,
                                                                form.owner.email,
                                                                void 0,
                                                                { trim: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["label"])
                                            ]),
                                            _createVNode(_unref(FieldWrapper), {
                                                label: _ctx.$t('organization.auto.contrasena_inicial'),
                                                "error-key": "owner.password"
                                            }, {
                                                default: _withCtx(() => [
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((form.owner.password) = $event)),
                                                        "data-test": "owner-password",
                                                        type: "password",
                                                        minlength: "8",
                                                        class: _normalizeClass(inputClass)
                                                    }, null, 512), [
                                                        [_vModelText, form.owner.password]
                                                    ])
                                                ]),
                                                _: 1
                                            }, 8, ["label"])
                                        ])),
                        (_unref(error))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_unref(error)), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("button", {
                            type: "button",
                            "data-test": "wizard-back",
                            class: "rounded-lg border px-4 py-2 text-sm text-eblack-700",
                            onClick: _cache[24] || (_cache[24] = ($event) => (currentStep.value === 'type' ? handleClose() : goBack()))
                        }, _toDisplayString(currentStep.value === "type" ? _ctx.$t("common.actions.cancel") : _ctx.$t("organization.auto.atras")), 1),
                        (currentStep.value !== 'owner')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                "data-test": "wizard-next",
                                type: "button",
                                class: "rounded-lg bg-egreen-500 px-4 py-2 text-sm font-medium text-white disabled:opacity-60",
                                onClick: goNext
                            }, _toDisplayString(_ctx.$t("organization.auto.continuar")), 1))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                "data-test": "wizard-submit",
                                type: "submit",
                                class: "rounded-lg bg-egreen-500 px-4 py-2 text-sm font-medium text-white disabled:opacity-60",
                                disabled: _unref(isSaving)
                            }, _toDisplayString(_unref(isSaving) ? _ctx.$t("organization.auto.guardando") : _ctx.$t("organization.auto.crear_organizacion")), 9, _hoisted_66))
                    ])
                ], 32)
            ]));
        };
    }
});
